import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import Check from "./Check.svg";
import CloseFilled from "./CloseFilled.svg";
import Form from "./form";
import P from "./p";
import Page from "./page";
import PageHeader from "./pageheader";
import Text from "./text";
import Title from "./title";
import { Widget } from "@uploadcare/react-widget";

function Icon({ style, children }) {
  return <div style={{ display: "inline", paddingRight: "1rem", ...style }}>{children}</div>;
}

function DO() {
  return (
    <span style={{ fontFamily: "TradeGothicCondensed", fontWeight: 600, color: "#3C8D40" }}>
      DO
    </span>
  );
}

function DO_NOT() {
  return (
    <span style={{ fontFamily: "TradeGothicCondensed", fontWeight: 600, color: "#D13135" }}>
      DO NOT
    </span>
  );
}

export default function UploadHeadshot({ mediaQuery, page, total }) {
  const nextUrl = `/apply/questions/`;
  const submitUrl = "/api/applications/v4/application/upload_headshot/";
  const {
    data: {
      results: [
        {
          submission: {
            upload_headshot: { info }
          }
        } = { submission: { upload_headshot: { info: null } } }
      ]
    } = {}
  } = useQuery(["application"]);
  const [form, setForm] = useState({ info, errors: null });
  function Item({ children }) {
    return (
      <div style={{ textAlign: "left", gridColumn: mediaQuery.isTabletOrMobile ? "span 2" : "" }}>
        {children}
      </div>
    );
  }
  const error = form.errors !== null ? form.errors["info"]?.reduce((n, m) => m, []) : null;
  return (
    <Page>
      <PageHeader title={`APPLICATION PAGE ${page} OF ${total}`} tagline="Upload your headshot.">
        <P>
          It’s important to have a great photo on file for your profile. First and foremost, it’s
          how our Front Desk staff identify you at check-in. Additionally, it’s how you represent
          yourself to other members when you take part in different groups and events.
        </P>
      </PageHeader>
      <Title style={{ marginBottom: "2rem" }}>please follow these guidelines</Title>
      <div
        style={{
          display: "grid",
          gap: "1rem",
          gridTemplateColumns: "1fr 1fr",
          letterSpacing: "0.25px",
          lineHeight: "20px",
          marginBottom: "2rem",
          textAlign: "center"
        }}
      >
        <Item>
          <Icon>
            <Check />
          </Icon>
          <DO /> upload a JPG, GIF or PNG
        </Item>
        <Item>
          <Icon>
            <Check />
          </Icon>
          <DO /> upload a picture at least 350px square
        </Item>
        <Item>
          <Icon>
            <CloseFilled />
          </Icon>
          <DO_NOT /> use blurry or unclear pictures
        </Item>
        <Item>
          <Icon>
            <CloseFilled />
          </Icon>
          <DO_NOT /> use pictures with a busy background
        </Item>
        <Item>
          <Icon>
            <CloseFilled />
          </Icon>
          <DO_NOT /> use pictures that contain other people
        </Item>
        <Item>
          <Icon>
            <CloseFilled />
          </Icon>
          <DO_NOT /> wear sunglasses
        </Item>
        <Item>
          <Icon>
            <CloseFilled />
          </Icon>
          <DO_NOT /> use pictures you are too close or too far away
        </Item>
        <Item>
          <Icon>
            <CloseFilled />
          </Icon>
          <DO_NOT /> use pictures that are too bright or too dark
        </Item>
        <Item>
          <Icon>
            <CloseFilled />
          </Icon>
          <DO_NOT /> use cartoon or graphic images
        </Item>
      </div>
      {form?.info && form?.info.cdnUrl && (
        <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
          <div
            style={{
              borderRadius: "50%",
              height: 200,
              marginBottom: "1rem",
              overflow: "hidden",
              width: 200
            }}
          >
            <img src={form?.info.cdnUrl} alt="Your current profile" />
          </div>
        </div>
      )}
      {error && <P style={{ color: "red", marginBottom: "1rem" }}>{error}</P>}
      <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
        <div
          style={{
            width: 350,
            height: 350,
            border: "1px dashed #737373",
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            alignContent: "space-evenly",
            alignItems: "center"
          }}
        >
          <div>
            <Text>Click the button to select a file:</Text>
          </div>
          <div>
            <Widget
              tabs="file camera"
              imagesOnly
              publicKey="2ae773955f4ce4d9722e"
              crop="1:1"
              id="file"
              onFileSelect={(file) => {
                if (file) {
                  file.done((info) => {
                    setForm({ ...form, info: info, updated: true });
                  });
                }
              }}
            />
          </div>
        </div>
      </div>
      <Form form={form} setForm={setForm} nextUrl={nextUrl} submitUrl={submitUrl}></Form>
    </Page>
  );
}
